import Script from 'next/script'
import React, { FunctionComponent, useEffect, ReactNode } from 'react'

interface KasadaConfiguration {
  method: string
  domain: string
  path: string
}

declare global {
  interface Window {
    KPSDK: {
      configure: (config: KasadaConfiguration[]) => void
    }
  }
}

interface KasadaProps {
  src: string
  urlList: string[]
  children?: ReactNode
}

export const Kasada: FunctionComponent<KasadaProps> = ({ src, urlList, children }) => {
  useEffect(() => {
    try {
      const domainList = urlList.map((url) => url.replace(/^https?:\/\//, ''))
      const kasadaConfig = domainList.map((domain) => ({ method: '*', domain, path: '*' }))

      window?.KPSDK?.configure(kasadaConfig)
    } catch (e) {}
  }, [urlList])

  return (
    <>
      <Script src={src} strategy='beforeInteractive' />
      {children}
    </>
  )
}
